/*
   Whether large reviews run overnight here, and from what size.
*/

import { queryOptions } from "@tanstack/react-query"

import { http } from "@/lib/http"
import { qk } from "@/lib/query-keys"
import type { components } from "@/types/api.gen"

export type BatchPolicy = components["schemas"]["BatchPolicyOut"]

/**
 * Whether this deployment runs large reviews overnight, and from how many pages.
 *
 * `enabled` false means the lane is off and the intake offers no choice at all:
 * a control the server will ignore is worse than none. `page_threshold` is the
 * size at which a review goes overnight without being asked, which is what the
 * automatic option resolves to.
 */
export const batchPolicyQuery = (enabled: boolean) =>
  queryOptions({
    queryKey: qk.reviews.batchPolicy(),
    queryFn: ({ signal }) => http.get<BatchPolicy>("/api/v1/reviews/batch-policy", { signal }),
    enabled,
    staleTime: 10 * 60_000,
  })
